import { Progress } from '@backstage/core-components';
import { useApi, errorApiRef } from '@backstage/core-plugin-api';
import React, { useEffect } from 'react';
import useAsync from 'react-use/esm/useAsync';
import { techRadarApiRef } from '../api.esm.js';
import Radar from './Radar/Radar.esm.js';

const useTechRadarLoader = (id) => {
  const errorApi = useApi(errorApiRef);
  const techRadarApi = useApi(techRadarApiRef);
  const { error, value, loading } = useAsync(
    async () => techRadarApi.load(id),
    [techRadarApi, id]
  );
  useEffect(() => {
    if (error) {
      errorApi.post(error);
    }
  }, [error, errorApi]);
  return { loading, value, error };
};
function matchFilter(filter) {
  const terms = filter?.toLocaleLowerCase("en-US").split(/\s/).map((e) => e.trim()).filter(Boolean);
  if (!terms?.length) {
    return () => true;
  }
  return (entry) => {
    const text = `${entry.title} ${entry.timeline[0]?.description || ""}`.toLocaleLowerCase("en-US");
    return terms.every((term) => text.includes(term));
  };
}
function RadarComponent(props) {
  const { loading, error, value: data } = useTechRadarLoader(props.id);
  const mapToEntries = (loaderResponse) => {
    return loaderResponse.entries.filter(matchFilter(props.searchText)).map((entry) => ({
      id: entry.key,
      quadrant: loaderResponse.quadrants.find((q) => q.id === entry.quadrant),
      title: entry.title,
      ring: loaderResponse.rings.find(
        (r) => r.id === entry.timeline[0].ringId
      ),
      timeline: entry.timeline.map((e) => {
        return {
          date: e.date,
          ring: loaderResponse.rings.find((a) => a.id === e.ringId),
          description: e.description,
          moved: e.moved
        };
      }),
      moved: entry.timeline[0].moved,
      description: entry.description || entry.timeline[0].description,
      url: entry.url,
      links: entry.links
    }));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, loading && /* @__PURE__ */ React.createElement(Progress, null), !loading && !error && data && /* @__PURE__ */ React.createElement(
    Radar,
    {
      ...props,
      rings: data.rings,
      quadrants: data.quadrants,
      entries: mapToEntries(data)
    }
  ));
}

export { RadarComponent };
//# sourceMappingURL=RadarComponent.esm.js.map
